import React from 'react'
import { Pill } from '../ui'

function formatDate(dateStr) {
  return new Date(dateStr).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
}

function formatTime(dateStr) {
  return new Date(dateStr).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' })
}

function FeedItem({ session, reportName, onClick }) {
  const date = session.scheduledAt || session.createdAt
  const isCompleted = session.status === 'completed'
  const isReady = session.status === 'ready'
  const isCancelled = session.status === 'cancelled'

  return (
    <div style={styles.item} onClick={onClick} role="button" tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && onClick()}>
      <div style={styles.left}>
        <span style={styles.reportName}>{reportName}</span>
        <span style={styles.date}>{formatDate(date)}{session.scheduledAt ? ` at ${formatTime(date)}` : ''}</span>
      </div>
      <Pill
        tone={isCompleted ? 'success' : isReady ? 'info' : isCancelled ? 'danger' : 'neutral'}
      >
        {isCompleted ? 'Completed' : isReady ? 'Ready' : isCancelled ? 'Cancelled' : 'Draft'}
      </Pill>
    </div>
  )
}

export function TeamFeed({ feedSessions, reports, loading, onSelectReportSession }) {
  const reportMap = {}
  for (const r of reports) {
    reportMap[r.reportId] = r.reportName || r.reportEmail
  }

  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>Recent sessions</h2>
      <p style={styles.subheading}>Activity across your direct reports</p>
      {loading ? (
        <p style={styles.loading}>Loading...</p>
      ) : feedSessions.length === 0 ? (
        <p style={styles.empty}>No recent sessions across your team.</p>
      ) : (
        <div style={styles.list}>
          {feedSessions.map((s) => (
            <FeedItem
              key={s.sessionId}
              session={s}
              reportName={reportMap[s.userId] || 'Unknown'}
              onClick={() => onSelectReportSession(s.userId, s.sessionId)}
            />
          ))}
        </div>
      )}
    </div>
  )
}

const styles = {
  container: {
    maxWidth: '640px',
    margin: '0 auto',
    padding: '48px 24px',
  },
  heading: {
    fontSize: '20px',
    fontWeight: 700,
    color: 'var(--text-primary)',
    margin: '0 0 4px',
  },
  subheading: {
    fontSize: '13px',
    color: 'var(--text-secondary)',
    margin: '0 0 24px',
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
  },
  item: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px 12px',
    borderRadius: '6px',
    cursor: 'pointer',
  },
  left: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
  },
  reportName: {
    fontSize: '13px',
    fontWeight: 600,
    color: 'var(--text-primary)',
  },
  date: {
    fontSize: '12px',
    color: 'var(--text-secondary)',
  },
  loading: {
    fontSize: '13px',
    color: 'var(--text-secondary)',
    margin: 0,
  },
  empty: {
    fontSize: '13px',
    color: 'var(--text-secondary)',
    margin: 0,
  },
}
